import React from "react";
import Skeleton from "@mui/material/Skeleton";
import classNames from "classnames";
import style from "../../Item.module.scss";

type SkeletonItemProps = {
  isTrending: boolean;
};

const SkeletonItem = ({ isTrending }: SkeletonItemProps) => {
  return (
    <div
      className={classNames(
        style.item,
        isTrending ? style.trendingSize : style.sectionSize
      )}
    >
      <Skeleton
        className={classNames(
          style.item,
          style.skeleton,
          isTrending ? style.trendingSize : style.sectionSizeSkeleton
        )}
        variant="rectangular"
        animation="wave"
        sx={{
          height: isTrending ? "100%" : "",
        }}
      />

      {!isTrending && (
        <>
          <Skeleton
            variant="text"
            className={classNames(style.item, style.skeleton, "mt-2")}
            width={"50%"}
            height={"15%"}
          />
          <Skeleton
            variant="text"
            className={classNames(style.item, style.skeleton)}
            width={"60%"}
            height={"15%"}
          />
        </>
      )}
    </div>
  );
};

export default SkeletonItem;
